import { IInfoBlockItem } from "shared/types";

export const infoBlockItemMap: {
  key: "contacts" | "places" | "files" | "images";
  dataKey: IInfoBlockItem;
}[] = [
  {
    key: "contacts",
    dataKey: IInfoBlockItem.contact,
  },
  {
    key: "places",
    dataKey: IInfoBlockItem.place,
  },
  {
    key: "files",
    dataKey: IInfoBlockItem.file,
  },
  {
    key: "images",
    dataKey: IInfoBlockItem.image,
  },
];
